import {JsonApiError} from '@/utils/jsonapiClient';

const MAX_DETAIL_LENGTH = 200;
// Rails-in-dev `errors[0].detail` includes the exception class + backtrace,
// e.g. "NoMethodError at /contracts/... undefined method '[]' for nil...".
// These shouldn't be rendered to users — fall back to the generic copy
// instead. Heuristic: exception class names end in "Error" or "Exception".
const STACK_TRACE_PREFIX = /^[A-Z]\w*(Error|Exception)\b/;

/**
 * Extracts a user-safe detail string from a thrown JsonApiError to use as a
 * flash subtitle. Returns undefined when the error isn't a JsonApiError or
 * when the message looks like a backend stack trace, so callers can fall
 * back to a generic copy (e.g. raiseFlashMessageError's default subtitle).
 */
export default function extractBackendErrorDetail(
  error: unknown
): string | undefined {
  if (!(error instanceof JsonApiError)) return undefined;
  const firstLine = error.message?.split('\n')[0]?.trim();
  if (!firstLine) return undefined;
  if (firstLine.length > MAX_DETAIL_LENGTH) return undefined;
  if (STACK_TRACE_PREFIX.test(firstLine)) return undefined;
  return firstLine;
}
